import { jsx as _jsx } from "react/jsx-runtime";
var data = {
    marginTop: '9px',
    marginBottom: '16px',
    color: '#ffffff',
};
var defaultProps = {
    data: data,
};
var HorizontalDivisor = function (_a) {
    var marginTop = _a.marginTop, marginBottom = _a.marginBottom, color = _a.color;
    return (_jsx("hr", { className: "divisor", style: {
            borderTop: "solid 0.5px " + color,
            marginTop: marginTop,
            marginBottom: marginBottom,
        } }, void 0));
};
export default HorizontalDivisor;
HorizontalDivisor.defaultProps = defaultProps;
